module.exports = __webpack_public_path__ + "d64b9a8ec6333c2db32be80562edcd81.png";